var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPrint(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.5846 10.6667H24.2513V4H8.2513V10.6667H6.91797C4.70464 10.6667 2.91797 12.4533 2.91797 14.6667V22.6667H8.2513V28H24.2513V22.6667H29.5846V14.6667C29.5846 12.4533 27.798 10.6667 25.5846 10.6667ZM10.918 6.66667H21.5846V10.6667H10.918V6.66667ZM21.5846 22.6667V25.3333H10.918V20H21.5846V22.6667ZM24.2513 20V17.3333H8.2513V20H5.58464V14.6667C5.58464 13.9333 6.18464 13.3333 6.91797 13.3333H25.5846C26.318 13.3333 26.918 13.9333 26.918 14.6667V20H24.2513Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2513 16.6667C24.9877 16.6667 25.5846 16.0697 25.5846 15.3333C25.5846 14.597 24.9877 14 24.2513 14C23.5149 14 22.918 14.597 22.918 15.3333C22.918 16.0697 23.5149 16.6667 24.2513 16.6667Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrint);
export default __webpack_public_path__ + "static/media/print.0dc3f8560ac7eb28c7a535434cc44967.svg";
export { ForwardRef as ReactComponent };